/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `pending` - Pending
 * * `viewable` - Viewable
 * * `failed` - Failed
 */
export enum FileStatusEnum {
    PENDING = 'pending',
    VIEWABLE = 'viewable',
    FAILED = 'failed',
}
